import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Usuario } from 'src/app/models/general/usuario.model';
import { UserValuesService } from 'src/app/services/utils/user-values.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/utils/snackBar.service';
import { TipoLoginFormEnum } from 'src/app/enums/configuracion.enum';
import { LoginService } from 'src/app/services/login/login.service';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit {
  bgImage = '../../../assets/images/Cofarsur/Cofarsur_BGLogin2.png'; //'../../../assets/images/Cofarsur/Cofarsur_BGLogin.png'; //'../../../assets/images/bg/loginBG.jpg';
  logoSniper = '../../../assets/images/SBOT/SBOT_LOGO.png';

  username: string;
  password: string;

  valid: boolean;
  Login_Wait_prm: number;

  sideNavWidth = '';
  recuperaCuenta: boolean;
  showLoaderLogin = false;
  showSelector = true;
  tipoFormulario: number;
  tipoLoginFormEnum = TipoLoginFormEnum;


  @Input() public set Login_ReciveLoginId_Void(IdAccion: number) {
    this.Login_Recibe_LoginAccion(IdAccion);
  }
  @Output() LoginAccion_Prm = new EventEmitter();
  @Output() Login_IdRol_Prm = new EventEmitter();
  @Output() autenticadoEmit = new EventEmitter();

  constructor(
    private dialog: MatDialog,
    private userValuesService: UserValuesService,
    private _snackBar: SnackBarService,
    private router: Router,
    private _loginService: LoginService
  ) {

  }

  ngOnInit() {
    this.showHideNavbar(1000);
    this.obtenerFechaPublicacion();

    //console.log('RLS 06/01/2022 23:30')
    //console.log('Init session log: ' + new Date());
  }

  obtenerFechaPublicacion() {
    this._loginService.obtenerFechaPublicacion().subscribe((data: any) => {
      if (data) {
        console.log('Fecha de publicación: ' + data.FechaPublicacion);
      }
    });
  }

  ngAfterViewInit() {
    this.recuperaCuenta = false;
  }

  switchBoxLogin() {
    this.showLoaderLogin = true;
    this.recuperaCuenta = !this.recuperaCuenta;
  }

  toggleSpinner(event) {
    this.showLoaderLogin = event;
  }

  showHideNavbar(tiempo: number) {
    setTimeout(() => {
      this.sideNavWidth = '18%';
    }, tiempo);
  }

  Login_Recibe_LoginAccion(idAccion: number) {
    if (idAccion == 1) {
      document.getElementById("mySidenav").style.width = "250px";
    }
    else {
      document.getElementById("mySidenav").style.width = "0";
    }
  }

  closeNav() {
    document.getElementById("mySidenav").style.width = "0";
    this.send_LoginAccion(0);
  }


  send_LoginAccion(idAccion: number) {
    this.LoginAccion_Prm.emit(idAccion);
  }


  setEmitIdRol(IdRol: number) {
    this.Login_IdRol_Prm.emit(IdRol);
  }

  setAutenticado() {
    this.autenticadoEmit.emit(true);
  }


  getTipoFormularioEmit(event) {
    this.tipoFormulario = event;
    this.showSelector = false;
  }

  volver() {
    this.showSelector = true;
    this.tipoFormulario = null;
  }

}
